import { cn } from "@/lib/class-control";

export const SectionCard: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => (
  <div className={cn("bg-darkblue rounded-lg", className)}>
    {children}
  </div>
);